const useValidatePassword: (pass: {oriPsw: string | null, newPsw: string | null, repPsw: string | null}, reseting?: boolean) => {status: boolean, msg:string} 
    = ({oriPsw, newPsw, repPsw}, reseting=false) => {
        let regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-={}:;"'<>?,./\[\]\\|])[A-Za-z\d!@#$%^&*()_+\-={}:;"'<>?,./\[\]\\|]{10,}$/g;

    if (!reseting && (!oriPsw || !newPsw || !repPsw))
        return {status: false, msg:'Complete todos los datos para continuar'};
    if (newPsw !== repPsw) 
        return {status: false, msg:'Las contraseñas no coinciden'};
    if (regex.test(newPsw!) == false) 
      return { status: false, msg: 'La contraseña debe contener por lo menos 10 caracteres, un número, una mayúscula y alguno de los siguientes caracteres especiales: ! @ # $ % ^ & * ( ) _ + - = { } : ; " \' <> ? , . / [ ] \ |'};

    return {status: true, msg:''};
}

export default useValidatePassword;